<template>
    <div class="tile is-ancestor">
        <article class="tile is-child has-text-centered is-12">
            <template v-if="account.logo">
                <img :src="account.logo" class="account-logo">
                <p class="subtitle">
                    {{ title }}
                    <br>
                </p>
            </template>
            <template v-else>
                <h1 class="title main">{{ title }}</h1>
            </template>
        </article>
    </div>
</template>

<script>
export default {
    props: {

        account: {
            type: Object,
            required: true,
        },

        title: {
            type: String,
            required: true,
        },
    },

    data () {
        return {};
    },

    computed: {
        hasLogo () {
            return _.has(this.account, 'logo');
        },

    },

};
</script>
